import React from 'react';
import SvgIconDPC from "./dpc-svg-icon";
import ShareIcon from "../assets/condividi.svg"

export default ({slug, ...otherProps}) => {

    const openSocial = (link) =>{
        if(typeof window !== `undefined`){
            window.open(link +  window.location.href,"", "height=200,width=200");
        }
    }

    return (
        <div className="col-xl-auto">
        {typeof document !== `undefined` /*&& document.cookie.indexOf('cookies_consent=true') >= 0*/ ?
                <div className="share-buttons d-none d-md-block reveal-content">
                    <div className="share-buttons-container">
                        <a href={`https://www.facebook.com/sharer/sharer.php?u=${slug}`}
                           title="Condividi su Facebook" target="_blank" rel="noreferrer">
                            <SvgIconDPC name='facebook-square'/>
                            <span className="sr-only">Condividi su Facebook</span>
                        </a>
                        <a href={`https://twitter.com/share?url=${slug}`}
                           title="Condividi su Twitter" target="_blank" rel="noreferrer">
                            <SvgIconDPC name='twitter-square'/>
                            <span className="sr-only">Condividi su Twitter</span>
                        </a>
                        <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${slug}`}
                           title="Condividi su LinkedIn" target="_blank" rel="noreferrer">
                            <SvgIconDPC name='linkedin-square'/>
                            <span className="sr-only">Condividi su LinkedIn</span>
                        </a>
                    </div>
                    <span>{typeof window !== "undefined" && window.location.pathname.split("/")[1] === 'it' ? 'Condividi' : 'Share'}</span>
                    <a href="#" className="share-buttons-trigger reveal-trigger" title="Condividi sui social network"
                       tabIndex="-1">
                        <ShareIcon/>
                        <span className="sr-only">Condividi sui social network</span>
                    </a>
                </div>

            : (typeof window !== "undefined" && window.location.pathname.split("/")[1] === 'it')
                ? <div className="share-buttons d-none d-md-block reveal-content">La condivisione sui social non è<br/> disponibile per il mancato consenso<br/> all'utilizzo di cookie di terze parti </div>
                : <div className="share-buttons d-none d-md-block reveal-content"> Social sharing is not available <br/>for non agreement to use of <br/>third-party cookies</div>
        }
        </div>
    )
}

